<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <app-settings-subnav></app-settings-subnav>
    </app-sidebar>

    <app-content>
        <div class="app__title">
            <h1>Claude</h1>
        </div>

        <p>Met de Resumo-connector kan Claude gegevens in Resumo lezen, aanmaken en wijzigen, met jouw rechten.</p>

        <div class="sectiontitle">Koppelen</div>
        <ol>
            <li>
                <strong>claude.ai of Claude Desktop:</strong> Settings → Connectors → <em>Add custom connector</em>, met als URL
                <code data-testid="claude-mcp-url">{{ mcpUrl }}</code>
                <button class="button button--outline button--small m-l-2" type="button" (click)="copyUrl()">Kopieer</button>
            </li>
            <li>
                <strong>Claude Code:</strong> <code>claude mcp add --transport http resumo {{ mcpUrl }}</code>
            </li>
        </ol>
        <p class="form-helptext">Claude opent daarna deze Resumo-omgeving om je te laten inloggen en toestaan.</p>

        <div class="sectiontitle m-t-4">Gekoppelde Claude-clients</div>
        <p *ngIf="loading()">Laden…</p>
        <p *ngIf="!loading() && connections().length === 0" data-testid="claude-no-connections">Er is nog geen Claude gekoppeld aan jouw account.</p>
        <table class="table-view" *ngIf="!loading() && connections().length > 0">
            <tr>
                <th>Client</th>
                <th>Gekoppeld op</th>
                <th>Geldig tot</th>
                <th></th>
            </tr>
            <tr *ngFor="let connection of connections()" data-testid="claude-connection">
                <td>{{ connection.clientName }}</td>
                <td>{{ connection.createdAt | date: 'short' }}</td>
                <td>{{ connection.expiresAt | date: 'shortDate' }}</td>
                <td>
                    <button class="button button--outline button--small" type="button" (click)="revoke(connection)">Intrekken</button>
                </td>
            </tr>
        </table>
    </app-content>
</app-app-holder>
